import { registerLocaleData } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  LOCALE_ID,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';

import { MessageComponent } from '../../../../components/messages/message/message.component';
import { NavigationSyncService } from '../services/navigation-sync.service';
import { SessionControlService } from '../services/session-control.service';
import { SystemConfigService } from '../../../../services/system-config.service';

import locales from '@angular/common/locales/es-MX';

registerLocaleData(locales, 'es-MX');

@Component({
  selector: 'app-main',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './main.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'es-MX' }],
  standalone: true,
  imports: [
    LoadingBarModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    RouterOutlet,
    MessageComponent,
  ],
})
export class MainComponent implements OnInit {
  @Output() onClick: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() onResize: EventEmitter<unknown> = new EventEmitter<unknown>();

  private readonly sessionControl = inject(SessionControlService);
  private readonly systemConfigService = inject(SystemConfigService);
  private readonly navigationService = inject(NavigationSyncService);

  ngOnInit(): void {
    void this.init();
  }

  @HostListener('window:mousemove')
  onMouseMove(): void {
    this.sessionControl.onUserActivity();
  }

  @HostListener('document:tap')
  onTap(): void {
    this.sessionControl.onUserActivity();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: unknown): void {
    this.sessionControl.onUserActivity();
    this.onClick.emit(event);
  }

  @HostListener('document:mousewheel')
  onScroll(): void {
    this.sessionControl.onUserActivity();
  }

  @HostListener('document:keydown')
  onKeydown(): void {
    this.sessionControl.onUserActivity();
  }

  @HostListener('window:resize', ['$event'])
  onListenerResize(event: unknown): void {
    this.onResize.emit(event);
  }

  private async init(): Promise<void> {
    this.navigationService.init();
    await this.systemConfigService.initialize();
    this.sessionControl.refreshSessionTimers();
  }
}
